import PropTypes from "prop-types";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { useNavigate } from "react-router-dom"; // React Router의 navigation 훅

function RotatingCardBack({ image, title, description, action }) {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (action && action.route) {
      navigate(action.route);
    }
  };

  return (
    <MKBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius="lg"
      coloredShadow="info"
      position="absolute"
      width="100%"
      height="100%" // 부모의 높이에 맞춤
      top={0}
      left={0}
      zIndex={5}
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba } }) =>
          `${linearGradient(
            rgba("rgb(196, 114, 200)", 0.85),
            rgba("rgb(196, 114, 200)", 0.85)
          )}, url(${image})`,
        backgroundSize: "cover",
        backfaceVisibility: "hidden",
        transform: "rotateY(180deg)",
      }}
    >
      <MKBox
        pt={{ xs: 6, sm: 8, md: 12 }}
        pb={2}
        px={{ xs: 2, sm: 3, md: 4 }}
        textAlign="center"
        lineHeight={1}
      >
        <MKTypography
          variant="h3"
          color="white"
          gutterBottom
          sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" } }} // 반응형 텍스트 크기
        >
          {title}
        </MKTypography>
        <MKTypography
          variant="body2"
          color="white"
          opacity={0.8}
          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" } }} // 반응형 설명 크기
        >
          {description}
        </MKTypography>
        {action && (
          <MKBox width="50%" mt={4} mb={2} mx="auto">
            <MKButton
              onClick={handleNavigation}
              color="white"
              size="small"
              fullWidth
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" }, // 반응형 버튼 크기
              }}
            >
              {action.label}
            </MKButton>
          </MKBox>
        )}
      </MKBox>
    </MKBox>
  );
}

RotatingCardBack.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  action: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      route: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ]),
};

export default RotatingCardBack;
